import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { setTermsAndPromos } from '../../store/reducer';
import { Checkbox, TermsAndPromosDiv } from './TermsAndPromos.styles';
import { Link } from '../shared.styles';
import { interactionsRioEvent } from '../../lib/rio/rioEvents';
import config from '../../config';
import { getTexts } from '../../lib/contentful/defaultTexts';
var TermsAndPromos = function TermsAndPromos(_ref) {
  var termsOfUse = _ref.termsOfUse;
  var dispatch = useAppDispatch();
  var _useAppSelector = useAppSelector(function (state) {
      return state;
    }),
    env = _useAppSelector.env,
    signup = _useAppSelector.signup;
  var gdpr = signup.gdpr;
  var termsLink = termsOfUse ? termsOfUse : config[env].termsOfUseLink;
  var privacyLink = config[env].privacyPolicyLink;
  var cookieLink = config[env].cookieNoticeLink;
  var _getTexts = getTexts(),
    _getTexts$signup = _getTexts.signup,
    readAndAgreeCheckboxLabel = _getTexts$signup.readAndAgreeCheckboxLabel,
    termsOfUseLinkText = _getTexts$signup.termsOfUseLinkText,
    andAcknowledgeTheLinkLabel = _getTexts$signup.andAcknowledgeTheLinkLabel,
    privacyPolicyText = _getTexts$signup.privacyPolicyText,
    andText = _getTexts$signup.andText,
    cookieNoticeText = _getTexts$signup.cookieNoticeText,
    promosCheckboxLabel = _getTexts$signup.promosCheckboxLabel;
  return /*#__PURE__*/React.createElement(TermsAndPromosDiv, {
    "data-test": "gdpr"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    inputId: "gdprTermsCheckbox",
    "data-test": "terms_of_use_checkbox",
    name: 'termsOfUse',
    size: 'small',
    align: 'top',
    checked: gdpr.termsOfUse,
    onChange: onCheckboxChange
  }, readAndAgreeCheckboxLabel, /*#__PURE__*/React.createElement(Link, {
    href: termsLink,
    onClick: onTermsOfUseClick,
    target: "_blank",
    "data-test": "terms_link"
  }, termsOfUseLinkText), ' ', andAcknowledgeTheLinkLabel, /*#__PURE__*/React.createElement(Link, {
    href: privacyLink,
    onClick: onPrivacyPolicyClick,
    target: "_blank",
    "data-test": "privacy_link"
  }, privacyPolicyText), ' ', andText, ' ', /*#__PURE__*/React.createElement(Link, {
    href: cookieLink,
    onClick: onCookieNoticeClick,
    target: "_blank",
    "data-test": "cookie_notice_link"
  }, cookieNoticeText)), /*#__PURE__*/React.createElement(Checkbox, {
    inputId: "gdprPromotionsCheckbox",
    "data-test": "promos_checkbox",
    name: 'promos',
    size: 'small',
    align: 'top',
    checked: gdpr.promos,
    onChange: onCheckboxChange
  }, promosCheckboxLabel));
  function onCheckboxChange(e) {
    dispatch(setTermsAndPromos(_objectSpread(_objectSpread({}, gdpr), {}, _defineProperty({}, e.target.name, e.target.checked))));
    if (e.target.checked && e.target.name === 'termsOfUse') {
      interactionsRioEvent({
        interaction: {
          type: 'accept',
          element: {
            type: 'radio',
            name: 'sign up legal opt in',
            region_name: 'sign up auth page'
          }
        }
      });
    } else if (e.target.checked && e.target.name === 'promos') {
      interactionsRioEvent({
        interaction: {
          type: 'accept',
          element: {
            type: 'radio',
            name: 'sign up promos opt in',
            region_name: 'sign up auth page'
          }
        }
      });
    }
  }
  function onTermsOfUseClick(e) {
    e.stopPropagation();
    interactionsRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'terms of use',
          region_name: 'sign up auth page',
          value: termsLink
        }
      }
    });
  }
  function onPrivacyPolicyClick(e) {
    e.stopPropagation();
    interactionsRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'privacy policy',
          region_name: 'sign up auth page',
          value: privacyLink
        }
      }
    });
  }
  function onCookieNoticeClick(e) {
    e.stopPropagation();
    interactionsRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'cookie notice',
          region_name: 'sign up auth page',
          value: cookieLink
        }
      }
    });
  }
};
export default TermsAndPromos;